import { render } from "./QuickPopover.vue?vue&type=template&id=6f211b5f"
import script from "./QuickPopover.vue?vue&type=script&lang=js"
export * from "./QuickPopover.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\php\\quick_wucode\\quick_wucode\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__